import { Injectable, inject } from '@angular/core';
import { CoreApiService, CoreHttpClient, CoreMeasure } from '@bepatient/core';
import { Platform } from '@ionic/angular';
import * as crypto from 'crypto-js';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ManualMeasureInfos } from './take-measure.models';

@Injectable()
export class TakeMeasureApiService {
  private http = inject(CoreHttpClient);
  private coreApiService = inject(CoreApiService);
  private platform = inject(Platform);

  loadMeasuresList(): Observable<Array<CoreMeasure>> {
    return this.http
      .get('/api/measures', {
        withMobiCredentials: true
      })
      .pipe(map(res => this.measuresListParser(res)));
  }

  saveManualMeasure(infos: ManualMeasureInfos): Observable<any> {
    return this.http.post(
      '/rest/v2/;activity_batch',
      this.manualMeasureParser(infos),
      { withMobiCredentials: true }
    );
  }

  private manualMeasureParser(infos: ManualMeasureInfos): any {
    const values = [];
    const activity = {
      type: 'measure',
      values: {},
      device: 'manual',
      activity_id: '',
      activity_model_id: infos.measure.activityModelId,
      timestamp: new Date(infos.measureData.measureDatetime).getTime(),
      send_timestamp: Date.now(),
      relay_receipt_timestamp: Date.now()
    };

    infos.measure.fields.forEach(field => {
      const value =
        infos.measureData[field.key].toString().indexOf(',') > -1
          ? infos.measureData[field.key].toString().replace(',', '.')
          : infos.measureData[field.key];
      const dotIdx = value.toString().indexOf('.');

      activity.values[field.key] = {
        value,
        unit: field.unit
      };

      values.push(
        field.key +
          field.unit +
          (dotIdx > -1 ? (value + '00').substr(0, dotIdx + 3) : value + '.00')
      );
    });

    const id =
      infos.instanceCode +
      infos.userId +
      activity.activity_model_id +
      activity.type +
      activity.device +
      activity.relay_receipt_timestamp +
      activity.timestamp +
      values.sort().join('');

    activity.activity_id = crypto.SHA1(id).toString(crypto.enc.Hex);

    return {
      randomId: Math.floor(10000 * Math.random()).toString(),
      activities: [activity],
      operating_system: 'Cordova',
      application_version: infos.appVersion || '',
      relay_sending_timestamp: Date.now()
    };
  }

  private measuresListParser(data: any): Array<CoreMeasure> {
    return ((data && data.items) || [])
      .filter(item => {
        return (
          (this.platform.is('android')
            ? item.meta && item.meta.type === 'measure'
            : item.meta &&
              item.meta.type === 'measure' &&
              item.meta.sub_type.toLowerCase() !== 'model-feetme') &&
          ((item.meta && item.meta.is_manual_measure) ||
            (item.meta && item.meta.device && item.meta.device.use_extra))
        );
      })
      .map(item => this.coreApiService.measureParser(item));
  }
}
